export default "__VITE_ASSET__DwUrVxhK__"